export const alertConstants = {
    LOADING: "ALERT_LOADING",
    SUCCESS: "ALERT_SUCCESS",
    ERROR: "ALERT_ERROR",
    CLEAR: "ALERT_CLEAR"
};



// WEBPACK FOOTER //
// ./src/_constants/alert.constants.js